import './components/app-shell';
import './components/cookie-consent';
import './pages/login-page';
import './pages/dashboard-page';
import './pages/content-list-page';
import './pages/content-detail-page';
import './pages/campaign-list-page';
import './pages/campaign-detail-page';
import './pages/profile-page';
import './pages/credits-page';
import './pages/legal-page';
import { isAuthenticated } from './api/client';
import { initAnalytics, setupAnalyticsListener } from './lib/analytics';
import { LEGAL_NOTICE_CONTENT } from './content/legal/aviso-legal';
import { PRIVACY_POLICY_CONTENT } from './content/legal/privacidad';
import { COOKIE_POLICY_CONTENT } from './content/legal/cookies';
import { ContentDetailPage } from './pages/content-detail-page';
import { ContentListPage } from './pages/content-list-page';
import { CampaignListPage } from './pages/campaign-list-page';
import { CampaignDetailPage } from './pages/campaign-detail-page';
import { DashboardPage } from './pages/dashboard-page';
import { LoginPage } from './pages/login-page';
import { ProfilePage } from './pages/profile-page';
import { CreditsPage } from './pages/credits-page';
import { LegalPage } from './pages/legal-page';
import { navigate, registerRoute, startRouter } from './router';

registerRoute('/', async () => {
  const authed = await isAuthenticated();
  await navigate(authed ? '/dashboard' : '/login', true);
  return null;
});

registerRoute('/login', async () => {
  const authed = await isAuthenticated();
  if (authed) {
    await navigate('/dashboard', true);
    return null;
  }
  return new LoginPage();
});

registerRoute('/dashboard', async () => {
  const authed = await isAuthenticated();
  if (!authed) return null;
  return new DashboardPage();
});

registerRoute('/content', async () => {
  const authed = await isAuthenticated();
  if (!authed) return null;
  return new ContentListPage();
});

registerRoute('/content/:id', async ({ id }) => {
  const authed = await isAuthenticated();
  if (!authed) return null;
  const page = new ContentDetailPage();
  page.generationId = id;
  return page;
});

registerRoute('/campaigns', async () => {
  const authed = await isAuthenticated();
  if (!authed) { await navigate('/login', true); return null; }
  return new CampaignListPage();
});

registerRoute('/campaigns/:id', async ({ id }) => {
  const authed = await isAuthenticated();
  if (!authed) { await navigate('/login', true); return null; }
  const page = new CampaignDetailPage();
  page.campaignId = id;
  return page;
});

registerRoute('/profile', async () => {
  const authed = await isAuthenticated();
  if (!authed) { await navigate('/login', true); return null; }
  return new ProfilePage();
});

registerRoute('/credits', async () => {
  const authed = await isAuthenticated();
  if (!authed) { await navigate('/login', true); return null; }
  return new CreditsPage();
});

registerRoute('/politica-privacidad', async () => {
  const page = new LegalPage();
  page.title = 'Política de Privacidad';
  page.content = PRIVACY_POLICY_CONTENT;
  return page;
});

registerRoute('/aviso-legal', async () => {
  const page = new LegalPage();
  page.title = 'Aviso Legal';
  page.content = LEGAL_NOTICE_CONTENT;
  return page;
});

registerRoute('/politica-cookies', async () => {
  const page = new LegalPage();
  page.title = 'Política de Cookies';
  page.content = COOKIE_POLICY_CONTENT;
  return page;
});

setupAnalyticsListener();
initAnalytics();

customElements.whenDefined('app-shell').then(() => {
  startRouter();
});
